import Events from './ads/media/Events';
import mediaEvents from './ads/media/mediaEvents';
import mint from './core/mint';
export * from './dependencies';
const api = {
    init(settings) {
        return mint.init(settings);
    },
    handleInstreamAds(adData) {
        return mint.handleInstreamAds(adData);
    },
    requestScreen(params) {
        return mint.requestScreen(params);
    },
    requestSlot(elementId) {
        return mint.requestSlot(elementId);
    },
    requestPremiumUnlockActivity(parameters) {
        return mint.requestPremiumUnlockActivity(parameters);
    },
    registerSlot(elementId, slotName, dimensions) {
        return mint.registerSlot(elementId, slotName, dimensions);
    },
    deregisterSlot(elementId) {
        return mint.deregisterSlot(elementId);
    },
    clearSlot(slotName, shouldIgnoreAdVisibilityEventOnce) {
        mint.clearSlot(slotName, shouldIgnoreAdVisibilityEventOnce);
    },
    clearState(stateName) {
        return mint.updateState(stateName, undefined);
    },
    updateState(stateName, value) {
        return mint.updateState(stateName, value);
    },
    updateUnlockDetails(unlock) {
        return mint.updateUnlockDetails(unlock);
    },
    getState(stateName) {
        return mint.getState(stateName);
    },
    updateLotameAudiences(audiences) {
        mint.updateLotameAudiences(audiences);
    },
    updateInstreamParams() {
        mint.updateInstreamParams();
    },
    disableAds() {
        return mint.disableAds();
    },
    async preload() {
        await mint.preload();
    },
    play(position) {
        mint.play(position);
    },
    pause() {
        mint.pause();
    },
    stop() {
        mint.stop();
    },
    volume(volume) {
        mint.volume(volume);
    },
    resize(width, height) {
        mint.resize(width, height);
    },
    event(...args) {
        return mediaEvents.event(...args);
    },
    getPalNonce() {
        return mint.getPalNonce();
    },
};
export default {
    ...api,
    Events,
};
